import { useState } from "react";
import client from "@/lib/api";
import { toast } from "sonner";
import { mt, MBtn, getGps, vibrate } from "./shared";

const OPTIONS = [
  ["officer_needs_assistance", "OFFICER NEEDS ASSISTANCE", "#DC2626"],
  ["immediate_backup", "IMMEDIATE BACKUP", "#DC2626"],
  ["emergency_traffic", "EMERGENCY TRAFFIC", "#EA580C"],
  ["active_threat", "ACTIVE THREAT", "#DC2626"],
  ["weapon_reported", "WEAPON REPORTED", "#EA580C"],
  ["foot_pursuit", "FOOT PURSUIT", "#D9A441"],
  ["vehicle_pursuit", "VEHICLE PURSUIT", "#D9A441"],
  ["responder_injured", "RESPONDER INJURED", "#DC2626"],
  ["citizen_injured", "CITIZEN SERIOUSLY INJURED", "#EA580C"],
  ["fire_ems_needed", "FIRE / EMS NEEDED", "#0EA5E9"],
  ["send_location", "SEND MY LOCATION", "#16A34A"],
];

export function MobileEmergency({ open, onClose, unit, incidentCc, onActivated }) {
  const [busy, setBusy] = useState(null);
  if (!open) return null;

  const fire = async (etype, label) => {
    setBusy(etype);
    vibrate([200, 80, 200, 80, 200]);
    const gps = await getGps();
    try {
      const r = await client.post("/mobile/emergency",
        { etype, unit, incident_cc: incidentCc || null, ...gps });
      toast.error(`${label} TRANSMITTED — dispatch + supervisors alerted`, { duration: 6000 });
      onActivated && onActivated(r.data);
      onClose();
    } catch (e) {
      // Never falsely claim transmission succeeded (offline / server failure).
      toast.error("⚠️ EMERGENCY TRANSMISSION FAILED — USE YOUR RADIO / AGENCY EMERGENCY PROCEDURE NOW", { duration: 12000 });
    } finally { setBusy(null); }
  };

  return (
    <div data-testid="mobile-emergency-sheet" className="fixed inset-0 z-[900] flex flex-col justify-end"
      style={{ background: "rgba(0,0,0,0.75)" }}>
      <div className="rounded-t-2xl p-4 pb-8 max-h-[85vh] overflow-y-auto"
        style={{ background: mt.bg, border: `2px solid ${mt.red}`, borderBottom: "none" }}>
        <div className="flex items-center justify-between mb-3">
          <span className="font-head font-bold text-base" style={{ color: mt.red }}>🚨 EMERGENCY — SELECT TYPE</span>
          <MBtn small outline color={mt.dim} onClick={onClose} testid="mobile-emergency-close">CANCEL</MBtn>
        </div>
        <div className="text-[11px] font-mono mb-3" style={{ color: mt.dim }}>
          Transmits your identity, unit {unit || "—"} and last GPS fix. Alerts dispatch, field &amp; comms supervisors. Fully audited.
        </div>
        <div className="grid grid-cols-1 gap-2">
          {OPTIONS.map(([k, label, color]) => (
            <MBtn key={k} full color={color} disabled={!!busy} onClick={() => fire(k, label)}
              testid={`mobile-emg-${k}`}>
              {busy === k ? "TRANSMITTING…" : label}
            </MBtn>
          ))}
        </div>
      </div>
    </div>
  );
}
